import { MessageCircle, Mail, ExternalLink, Headphones } from "lucide-react";
import { useCompanyContact, waLink } from "../lib/companyContact";

export default function ContactoPage() {
  const { contact } = useCompanyContact();
  const SUPPORT_EMAIL = contact.support_email;
  return (
    <div className="min-h-screen bg-sand pb-16" data-testid="contacto-page">
      <div className="container-main py-10 max-w-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-blue-500/10 text-blue-600 flex items-center justify-center">
            <Headphones className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-3xl font-heading font-bold text-agave">Contacto</h1>
            <p className="text-sm text-neutral-600">Estamos aquí para ayudarte.</p>
          </div>
        </div>

        <div className="card-base mb-4">
          <p className="text-neutral-700 leading-relaxed mb-6">
            Para soporte general, dudas sobre reservas, anfitriones, verificación, pagos o funcionamiento de la
            plataforma, contáctanos por WhatsApp o correo electrónico.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <a
              href={waLink(contact.whatsapp_number)}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-emerald-600 hover:bg-emerald-700 text-white font-medium px-5 py-3 rounded-xl transition-colors flex items-center justify-center gap-2"
              data-testid="contacto-whatsapp-cta"
            >
              <MessageCircle className="w-5 h-5" />
              Contactar por WhatsApp
            </a>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-3 rounded-xl transition-colors flex items-center justify-center gap-2"
              data-testid="contacto-email-cta"
            >
              <Mail className="w-5 h-5" />
              {SUPPORT_EMAIL}
              <ExternalLink className="w-3.5 h-3.5 opacity-70" />
            </a>
          </div>
        </div>

        <p className="text-xs text-neutral-500 italic">
          Tiempo promedio de respuesta: menos de 30 minutos en horario laboral (9am–9pm hora del Pacífico).
        </p>
      </div>
    </div>
  );
}
